import { useEffect, useState } from "react";
import {
  Autocomplete,
  CurrencyInput,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "../../../components";
import { filtrosUrl, value } from "../../../helpers";
import {
  GrupoPessoasService,
  TipoContribuinteClienteService,
} from "../../../services";
import { cacheApi, responseErros, unformatPrice } from "../../../utils";

export default function TabCliente({
  clienteSelecionado,
  linhaSelecionada,
  cacheDto,
  setCacheDto,
  inputErros,
}) {
  const [listaGrupoPessoa, setListaGrupoPessoa] = useState([]);
  const [tiposContribuinte, setTiposContribuinte] = useState([]);
  const [cliente, setCliente] = useState(clienteSelecionado);

  const grupoPessoasService = new GrupoPessoasService();
  const tipoContribuinteClienteService = new TipoContribuinteClienteService();

  useEffect(() => {
    buscarTipoContribuinte();
    buscaGruposPessoas();
  }, []);

  const buscaGruposPessoas = async () => {
    const filtros = {
      ativado: true,
      tipoPessoa: 1,
      restritiva: true,
    };
    const label = filtrosUrl.getUrl(filtros, grupoPessoasService.urlBase);
    const cacheBody = {
      apiFunction: grupoPessoasService.getAllFiltroAvancado(filtros),
      dto: { cacheDto, setCacheDto },
    };
    const res = await cacheApi(label, cacheBody);
    if (!res.isAxiosError) {
      setListaGrupoPessoa(res.data.rows);
    } else {
      responseErros(res);
    }
  };

  const buscarTipoContribuinte = async () => {
    const cacheBody = {
      timeMinutes: 60,
      apiFunction: tipoContribuinteClienteService.getAll(),
      dto: { cacheDto, setCacheDto },
    };
    const res = await cacheApi(
      tipoContribuinteClienteService.urlBase,
      cacheBody,
    );
    if (!res.isAxiosError) {
      setTiposContribuinte(res.data);
    } else {
      responseErros(res);
    }
  };

  const handleChangeAutocomplete = (name, value) => {
    clienteSelecionado.setAtributo(name, value?.id);
    setCliente({ ...clienteSelecionado });
  };

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    clienteSelecionado.setAtributo(name, value);
    setCliente({ ...clienteSelecionado });
  };

  const handleInputBlur = (e) => {
    const { name, value } = e.target;
    clienteSelecionado.setAtributo(name, unformatPrice(value));
    setCliente({ ...clienteSelecionado });
  };

  return (
    <Grid container spacing={2} className="mt-1">
      <Grid item xs={3}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="grupoPessoaId"
            name="grupoPessoaId"
            options={listaGrupoPessoa}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => (option.nome ? option.nome : "")}
            filterSelectedOptions
            onChange={(_, value) =>
              handleChangeAutocomplete("grupoPessoaId", value)
            }
            renderInput={(params) => (
              <TextField {...params} label="Grupos de Pessoas" />
            )}
            value={value.autoComplete(listaGrupoPessoa, cliente.grupoPessoaId)}
          />
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <Select
          label="Consumidor Final"
          id="indicadorConsumidorFinal"
          name="indicadorConsumidorFinal"
          margin="normal"
          value={cliente?.indicadorConsumidorFinal || false}
          required
          onChange={handleChangeInput}
          error={inputErros?.get(`[${linhaSelecionada}].cliente.indicadorConsumidorFinal`)}
        >
          <MenuItem value={true}>Sim</MenuItem>
          <MenuItem value={false}>Não</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={3}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="tipoContribuinteId"
            name="tipoContribuinteId"
            options={tiposContribuinte}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) =>
              option.descricao ? option.descricao : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tipo Contribuinte"
                required
                error={inputErros?.get(`[${linhaSelecionada}].cliente.tipoContribuinteId`)}
              />
            )}
            onChange={(e, value) =>
              handleChangeAutocomplete("tipoContribuinteId", value)
            }
            value={value.autoComplete(
              tiposContribuinte,
              cliente.tipoContribuinteId,
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <CurrencyInput
          label="Limite de Crédito"
          name="limiteCompra"
          onBlur={handleInputBlur}
          value={cliente?.limiteCompra ?? ""}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Mensagem para mostrar na venda"
          name="mensagemVenda"
          onChange={handleChangeInput}
          value={cliente?.mensagemVenda ?? ""}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
